import React from "react";
import { ResponsiveContainer, LineChart, Line, YAxis, Tooltip } from "recharts";

export default function Sparkline({ data, color = "#3EB6F0", height = 32, testId }) {
  const points = (data || []).map((v, i) => ({ i, v }));
  if (points.length < 2) {
    return <div className="text-[10px] text-slate-600 font-mono" data-testid={testId}>—</div>;
  }
  return (
    <div style={{ width: 90, height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={points} margin={{ top: 2, right: 2, left: 2, bottom: 2 }}>
          <YAxis hide domain={["dataMin", "dataMax"]} />
          <Tooltip
            cursor={false}
            contentStyle={{ background: "#0a0f1c", border: "1px solid #1E293B", fontSize: 10, padding: 4 }}
            labelStyle={{ display: "none" }}
            formatter={(v) => [`${v} L/h`, ""]}
          />
          <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.6} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
